import { render, staticRenderFns } from "./QueryPreview.vue?vue&type=template&id=87dfb95e&"
import script from "./QueryPreview.vue?vue&type=script&lang=js&"
export * from "./QueryPreview.vue?vue&type=script&lang=js&"
import style0 from "./QueryPreview.vue?vue&type=style&index=0&id=87dfb95e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports